import React, { useState, useEffect, use } from 'react';
import { useTheme } from '../theming/default_theme';

const Header: React.FC = () => {
    const theme = useTheme();
    const [greeting, setGreeting] = useState(''); 
    const loggedinUser = localStorage.getItem('loggedinUser');
    const userPhoneNumber = loggedinUser ? JSON.parse(loggedinUser).phoneNumber || 'prashant@nayonika.com' : 'prashant@nayonika.com';

    useEffect(() => {
        const currentHour = new Date().getHours();
        if (currentHour < 12) {
            setGreeting('Good Morning');
        } else if (currentHour < 18) {
            setGreeting('Good Afternoon');
        } else {
            setGreeting('Good Evening');
        }
    }, [])

    const handleLogoutClick = () => {
        localStorage.removeItem('jwtToken'); // Adjust the key name as per your storage
        localStorage.removeItem('loggedinUser'); // Remove any other user-related data if necessary
        window.location.href = '/'; // Redirect to the login page or home page
    };

    return (
        <div className="flex flex-row w-full h-[80px]  pb-2 ">

            <div className="absolute top-4 right-[3%] flex items-center gap-2 block">
                <div className="flex flex-row gap-x-5 items-center">
                    <span style={{ fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightBold, fontSize: theme.typography.h2.fontSize, color: theme.colors.text }}>
                        {userPhoneNumber}
                    </span>
                    <img src="/logout.png" alt="Logout icon" style={{ width: '40px', height: '40px', borderRadius: '30%', cursor: "pointer" }} onClick={handleLogoutClick} />
                </div>
            </div>
        </div>
    );
};
export default Header;